import { useEffect, useState, useRef } from 'react';
import { isEditModeActive } from '@portal-internet/bff';
import styles from './modulavis.module.scss';
import Icona from 'components/corporatiu/Icona';
import Enllac from 'components/corporatiu/Enllac';
import { useRouter } from 'next/router';
import { useModulAvis } from 'hooks/useModulAvis';
import __isEmpty from 'lodash/isEmpty';

const ModulAvis = (props) => {
    const router = useRouter();
    const isEditMode = isEditModeActive(router?.query);
    const { setModulAvisActive } = useModulAvis();

    const [items, setItems] = useState([]);
    const closeButtonRef = useRef(null);

    useEffect(() => {
        const avisos = Array.isArray(props.item) ? props.item : props.item || [];
        setModulAvisActive(avisos.length > 0);

        return () => {
            setModulAvisActive(false);
        };
    }, [props.item, setModulAvisActive]);

    useEffect(() => {
        const fetchAvisos = async () => {
            try {
                const avisos = Array.isArray(props.item) ? props.item : props.item || [];
                if (!__isEmpty(avisos)) {
                    const avisosFormatted = avisos.map((item, index) => ({
                        id: item.id,
                        titol: item.titol,
                        entradeta: item.entradeta,
                        url: item.url
                    }));

                    const hiddenAvisos = JSON.parse(sessionStorage.getItem('hiddenAvisos')) || [];
                    const filteredAvisos = avisosFormatted.filter((item) => !hiddenAvisos.includes(item.id));

                    setItems(filteredAvisos);
                }
            } catch (error) {
                console.error('Error carregant els avisos:', error);
            }
        };

        !isEditMode && fetchAvisos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!__isEmpty(items) && closeButtonRef.current) {
            closeButtonRef.current.focus();
        }
    }, [items]);

    const focusPrimerElementFocusable = () => {
        const primerElementFocusable = document.querySelector(
            'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        );
        if (primerElementFocusable) {
            primerElementFocusable.focus();
        }
    };

    const toggleVisibility = (id) => {
        setItems((prevItems) => prevItems.filter((item) => item.id !== id));

        const hiddenAvisos = JSON.parse(sessionStorage.getItem('hiddenAvisos')) || [];
        hiddenAvisos.push(id);
        sessionStorage.setItem('hiddenAvisos', JSON.stringify(hiddenAvisos));

        // Elimina el focus de l'element actual
        focusPrimerElementFocusable();
    };

    const handleKeyPress = (event, id) => {
        if (event.key === 'Enter' || event.key === ' ') {
            toggleVisibility(id);
        }
    };

    return (
        <div
            className={styles.modul_davis_wrapper}
            {...(!__isEmpty(items) && {
                'role': 'dialog',
                'aria-modal': 'true',
                'aria-labelledby': 'avis-titol'
            })}
        >
            {items.map((item) => (
                <div key={item.id} className={styles.modul_davis_contenidor}>
                    <Icona
                        className={styles.ic_info_contorn}
                        icona='ic_info_contorn'
                        alt='Info'
                        mida='40'
                        isBlanc={true}
                        path='corporatiu'
                    />
                    <div className={styles.modul_davis}>
                        {__isEmpty(item.url) ? (
                            <strong className={styles.modul_davis_titol} data-testid='avis-titol' id='avis-titol'>
                                {item.titol}
                            </strong>
                        ) : (
                            <Enllac href={item.url} className={styles.modul_davis_titol} title={item.titol}>
                                {item.titol}
                            </Enllac>
                        )}
                        <button
                            ref={closeButtonRef} // Assigna la referència al botó de tancar
                            className={styles.ic_tanca_wrapper}
                            onClick={() => toggleVisibility(item.id)}
                            onKeyDown={(event) => handleKeyPress(event, item.id)} // Gestiona Enter i Espai
                            data-testid='avis-boto-tanca'
                        >
                            <Icona className={styles.ic_tanca_icon} icona='tanca' alt='Tanca' mida='20' isBlanc={true} />
                        </button>
                    </div>
                    <div
                        className={styles.modul_davis_entradeta}
                        dangerouslySetInnerHTML={{
                            __html: item.entradeta.replace(/\r?\n/g, '<br />')
                        }}
                    ></div>
                </div>
            ))}
        </div>
    );
};

export default ModulAvis;
